import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.function.name";
import "core-js/modules/es.string.pad-start";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp, loadMoreList, tool, commonData } from "@/mixins/index";
export default {
  mixins: [popUp, loadMoreList, tool, commonData],
  data: function data() {
    var _this = this;

    var validateScoreGroup = function validateScoreGroup(rule, value, callback) {
      var _this$formData = _this.formData,
          win = _this$formData.win,
          draw = _this$formData.draw,
          loss = _this$formData.loss; // 核心修改：显式判断是否为 空值（''/undefined/null），而非直接布尔判断

      var isWinEmpty = win === '' || win === undefined || win === null;
      var isDrawEmpty = draw === '' || draw === undefined || draw === null;
      var isLossEmpty = loss === '' || loss === undefined || loss === null; // 场景1：全为空值（''/undefined/null）→ 校验通过

      if (isWinEmpty && isDrawEmpty && isLossEmpty) {
        callback();
        return;
      } // 场景2：有一个不是空值，但至少一个是空值 → 校验失败


      if (isWinEmpty || isDrawEmpty || isLossEmpty) {
        callback(new Error('胜利、平局、失败需全部填写（或全部不填）'));
        return;
      } // 可选：校验是否为数字（包括0，根据业务需求保留）
      // if (isNaN(Number(win)) || isNaN(Number(draw)) || isNaN(Number(loss))) {
      //   callback(new Error('胜利、平局、失败仅允许输入数字'));
      //   return;
      // }


      callback();
    };

    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        age_group: "",
        start_date: "",
        end_date: "",
        entry_fee: '',
        max_teams: "",
        format: "",
        description: '',
        tournament_type: '',
        win: '',
        draw: '',
        loss: '',
        searchDateArr: []
      },
      imgList: [],
      ageGroupList: [],
      tournamentTypeList: [{
        label: '正式赛事',
        value: 'official'
      }, {
        label: '友谊赛',
        value: 'friendly'
      }, {
        label: '青少年赛事',
        value: 'youth'
      }],
      formatList: [{
        label: '联赛制',
        value: 'league'
      }, {
        label: '淘汰制',
        value: 'knockout'
      }, {
        label: '小组赛+淘汰赛',
        value: 'group+knockout'
      }],
      // 修复：配置日期选择器禁用规则
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          var today = new Date();
          today.setHours(0, 0, 0, 0);
          return date < today; // 禁用今天之前的日期
        }
      },
      rules: {
        name: [{
          required: true,
          message: "请输入名称",
          trigger: "blur"
        }],
        age_group: [{
          required: true,
          message: "请选择年龄组",
          trigger: "blur"
        }],
        searchDateArr: [{
          required: true,
          type: 'array',
          message: "请选择时间",
          trigger: "blur"
        }],
        scoreGroup: [{
          validator: validateScoreGroup,
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  // 修复：监听改为非immediate（避免初始化干扰）
  watch: {
    'formData.searchDateArr': {
      handler: function handler(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          if (newVal && newVal.length === 2) {
            this.formData.start_date = newVal[0];
            this.formData.end_date = newVal[1];
          } else {
            this.formData.start_date = '';
            this.formData.end_date = '';
          }

          this.$nextTick(function () {// this.$refs.ruleForm?.validateField('searchDateArr');
          });
        }
      },
      deep: true
    }
  },
  methods: {
    init: function init(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas, formatDate, startDate, endDate;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 第一步：重置表单和日期选择器（关键）
                // this.$nextTick(() => {
                //   // 重置表单校验状态
                //   if (this.$refs.ruleForm) {
                //     this.$refs.ruleForm.resetFields();
                //   }
                //   // 重置日期选择器值
                //   if (this.$refs.datePicker) {
                //     this.$refs.datePicker.setValue([]);
                //   }
                // });
                // 第二步：初始化空表单（保证响应式）
                _this2.formData = {
                  id: "",
                  name: '',
                  age_group: "",
                  start_date: "",
                  end_date: "",
                  entry_fee: '',
                  max_teams: "",
                  format: "",
                  description: '',
                  tournament_type: '',
                  win: '',
                  draw: '',
                  loss: '',
                  searchDateArr: []
                };

                _this2.getAgeGroupListFn();

                if (data) {
                  console.log("编辑数据：", data);

                  _this2.copyPrimitive();

                  datas = JSON.parse(JSON.stringify(data)); // 第三步：标准化日期格式（核心修复）

                  formatDate = function formatDate(dateStr) {
                    if (!dateStr) return '';
                    var date = new Date(dateStr);
                    if (isNaN(date.getTime())) return '';
                    return "".concat(date.getFullYear(), "-").concat(String(date.getMonth() + 1).padStart(2, '0'), "-").concat(String(date.getDate()).padStart(2, '0'));
                  }; // 第四步：分步赋值（避免响应式丢失）


                  _this2.formData.id = datas.id || '';
                  _this2.formData.name = datas.name || '';
                  _this2.formData.age_group = datas.age_group || '';
                  _this2.formData.entry_fee = datas.entry_fee || '';
                  _this2.formData.max_teams = datas.max_teams || '';
                  _this2.formData.format = datas.format || '';
                  _this2.formData.description = datas.description || '';
                  _this2.formData.tournament_type = datas.tournament_type || ''; // 积分规则赋值

                  if (datas.points_rules) {
                    _this2.formData.win = datas.points_rules.win;
                    _this2.formData.draw = datas.points_rules.draw;
                    _this2.formData.loss = datas.points_rules.loss;
                  } // 日期回显（强制标准化）


                  startDate = formatDate(datas.start_date_format);
                  endDate = formatDate(datas.end_date_format);

                  if (startDate && endDate) {
                    // 使用$set保证响应式
                    _this2.$set(_this2.formData, 'searchDateArr', [startDate, endDate]);
                  }

                  _this2.copyData();
                }

                _this2.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    seachDateChange: function seachDateChange(val) {
      console.log("日期选择确认：", val);

      if (val) {
        // 强制更新（兜底）
        this.$set(this.formData, 'searchDateArr', val);
      } else {
        this.$set(this.formData, 'searchDateArr', []);
      }
    },
    getAgeGroupListFn: function getAgeGroupListFn() {
      var _this3 = this;

      this.$api.ageGroupList().then(function (res) {
        if (res.code == 200) {
          _this3.ageGroupList = res.data;
        }
      });
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("提交数据：", _this4.formData);

                _this4.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var reqFn = _this4.formData.id ? 'updateTour' : 'addTour';
                    var data = JSON.parse(JSON.stringify(_this4.formData)); // 兼容日期赋值

                    if (Array.isArray(data.searchDateArr) && data.searchDateArr.length === 2) {
                      data.start_date = data.searchDateArr[0];
                      data.end_date = data.searchDateArr[1];
                    }

                    delete data.searchDateArr;

                    _this4.$api[reqFn](data).then(function (res) {
                      if (res.code == 200) {
                        _this4.$message.success(_this4.formData.id ? '修改成功' : '添加成功');

                        _this4.$emit('change');

                        _this4.dialogFormVisible = false;
                      } else {
                        _this4.$message.error(res.msg || '操作失败');
                      }
                    });
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};